import Decimal from "decimal.js";
import React from "react";

import SrrRowBase from "./SrrRowBase";

const ReportReturnSRR3ByCar = ({ row, items, group }) => {
  const dealerArr = [
    "DealerName",
    "INN",
    "ent_id",
    "subject",
    "FO",
    "city",
    "family",
  ];

  let optionsTable = dealerArr.map((el) => row[el]);

  const lastItem = {
    sumServiceCount: new Decimal(0),
    sumSaleCount: new Decimal(0),
    sumPercent: new Decimal(0),
  };

  const renderItem = [
    ...row.periods
      .map((el) => {
        lastItem.sumServiceCount = lastItem.sumServiceCount.plus(
          new Decimal(el.TO1.countService)
            .plus(el.TO2.countService)
            .plus(el.TO3.countService)
            .plus(el.TO4 ? el.TO4.countService : 0)
            .plus(el.TO5 ? el.TO5.countService : 0)
        );

        lastItem.sumSaleCount = lastItem.sumSaleCount.plus(
          new Decimal(el.TO1.countSale)
            .plus(el.TO2.countSale)
            .plus(el.TO3.countSale)
            .plus(el.TO4 ? el.TO4.countSale : 0)
            .plus(el.TO5 ? el.TO5.countSale : 0)
        );

        const data = [
          el.TO1.countSale,
          el.TO1.countService,
          el.TO1.percent,
          el.TO2.countSale,
          el.TO2.countService,
          el.TO2.percent,
          el.TO3.countSale,
          el.TO3.countService,
          el.TO3.percent,
        ];

        if (el.TO4) {
          data.push(el.TO4.countSale, el.TO4.countService, el.TO4.percent);
        }
        if (el.TO5) {
          data.push(el.TO5.countSale, el.TO5.countService, el.TO5.percent);
        }

        return data.map((item) =>
          item instanceof Decimal ? item.toNumber() : item
        ); // Преобразование Decimal в числа
      })
      .flat(),

    lastItem.sumSaleCount.toNumber().toFixed(2),
    lastItem.sumServiceCount.toNumber().toFixed(2),
    lastItem.sumServiceCount.gt(0) && lastItem.sumSaleCount.gt(0)
      ? lastItem.sumServiceCount
          .div(lastItem.sumSaleCount)
          .times(100)
          .toFixed(2)
      : "0.00", // Если деление невозможно, выводим "0.00"
  ];

  return <SrrRowBase leadingCells={optionsTable} cells={renderItem} />;
};

export default ReportReturnSRR3ByCar;
